import { useState, useEffect, useRef, useCallback } from "react";
import { useLanguageContext } from "../../../Context/LanguageContext";
import EquipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import equipmentGroupStore from "../../../Stores/EquipmentGroupStore";
import EquipmentGroupContants from "../../../Constants/EquipmentGroupConstants";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import {
  useCurrentPageActionContext,
  useMainGridSortContext,
  useMainGridSortActionContext,
  usePageSizeActionContext,
  useAMGSelectedActionsContext,
} from "../../../Context/GlobalContext";
import {
  useItemSelectedFilterContext,
  useItemSelectedFilterActionsContext,
  useEquipmentStatusActionsContext,
  useEquipmentStatusContext,
  useSelectedFilterActionsContext,
} from "../../../Context/GridEquipListContext";
import { toast } from "react-toastify";
import { Tooltip } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { LuView } from "react-icons/lu";
import MuiDataGridPro from "../../Dashboard/MuiDataGridPro";
import GridHeaderBar from "../../Dashboard/MuiDataGridPro/GridHeaderBar";
import GridColumn_SettingActions from "../../../Actions/GridColumn_SettingActions";
import {
  DropDownChange,
  dropDownFilter,
  extractFilterOperator,
  FilterApplyHandle,
  filterModel,
} from "../../Dashboard/MuiDataGridPro/HelperDashboard";
import gridColSettingStore from "../../../Stores/GridColumn_SettingStores";
import GridColSettingConstants from "../../../Constants/GridColumn_SettingConstants";
import { CreateFilterModel } from "../../Dashboard/MuiDataGridPro/SaveUserFilter";
import ScrapImageList from "./ScrapImageList";

export default function ScrappedEquipments() {
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const sortBy = useMainGridSortContext();
  const UpdateSortBy = useMainGridSortActionContext();
  const itemSelectedFilter = useItemSelectedFilterContext();
  const updateListSelectedFilter = useItemSelectedFilterActionsContext();
  const equipmentStatus = useEquipmentStatusContext();
  const updateEquipmentStatus = useEquipmentStatusActionsContext();
  const updateSelectedFilter = useSelectedFilterActionsContext();
  const UpdateCurrentPage = useCurrentPageActionContext();
  const UpdatePageSize = usePageSizeActionContext();
  const UpdateSelectedAnlageG = useAMGSelectedActionsContext();

  const [egId, setEgId] = useState("");
  const [egList, setEgList] = useState([]);
  const [tableData, setTableData] = useState(null);
  const [state, setState] = useState("Active");
  const [pinnedColumns, setPinnedColumns] = useState({
    left: [],
    right: [],
  });
  const [saveFilterlist, setSaveFilterList] = useState([]);
  const [equpId, setEqupId] = useState("");
  const [openScrapImageListView, setOpenScrapImageListView] = useState(false);

  const itemSelectedFilterRef = useRef();
  const [shouldFetch, setShouldFetch] = useState(false);
  const [apiArgs, setApiArgs] = useState(null);

  const buildFilterList = (reportCode, equipmentStatus, itemSelectedFilter) => {
    let FilterList = [...itemSelectedFilter];
    return FilterList;
  };

  const loadData = (callFilter) => {
    const EquipmentGroupID = egId;
    const defaultSortKey = "InventarNr";
    const sortOrder = sortBy.order === "" ? "asc" : sortBy.order;
    const sortKey = sortBy.key === "" ? defaultSortKey : sortBy.key;

    let FilterList = buildFilterList(
      "ScrapEquipment",
      equipmentStatus,
      itemSelectedFilter,
    );

    EquipmentGroupActions.getEquipmentList2(
      "ScrapEquipment",
      sortOrder,
      EquipmentGroupID,
      parseInt(1),
      parseInt(1000),
      sortKey,
      null,
      FilterList,
    );

    GridColumn_SettingActions.getSaveFilterList(
      EquipmentGroupID,
      "ScrapEquipment",
    );
  };

  const handleColumnPin = useCallback((_value) => {
    setPinnedColumns(_value);
  }, []);

  useEffect(() => {
    itemSelectedFilterRef.current = itemSelectedFilter;
  }, [itemSelectedFilter]);

  const handleResponse = useCallback(
    (_response) => {
      if (_response) {
        let headerName = [];
        let paginationData = null;
        let _header = _response.headers;
        let _rows = _response.rows;
        let _action = _response.actions;
        let indexofcolToSkipdata = 0;
        _header.map((item, index) => {
          if (!item.isVisible) {
            indexofcolToSkipdata = index;
          }
          headerName.push(item.name);
        });

        paginationData = {
          pageSizeOptions: [50, 100, 500, 1000],
          rowCount: _response.pagingInfo.rowCount,
          currentPage: _response.pagingInfo.currentPage,
          pageSize: _response.pagingInfo.pageSize,
        };

        let _gridAction = null;
        if (_action.length > 0) {
          let _items = {};
          _action.map((item, i) => {
            switch (item.name) {
              case "DataConfiguration":
                _items["DataConfiguration"] = item;
                break;
              case "ExcelExport":
                _items["ExcelExport"] = item;
                break;
            }
          });
          _gridAction = {
            actionName: _items,
            filterList: _response.filters,
            show: true,
            pageInfo: {
              currentpage: _response.pagingInfo.currentPage,
              pagSize: _response.pagingInfo.pageSize,
            },
          };
        }

        let firstItemOfColumn = null;
        const formattedData = _rows.map((row, index) => {
          const rowData = {};
          row.forEach((cell, cellIndex) => {
            if (cellIndex > indexofcolToSkipdata)
              if (cellIndex === indexofcolToSkipdata + 1) {
                firstItemOfColumn = headerName[cellIndex];
              }
            rowData[headerName[cellIndex]] = cell.value;
            if (cell.stype) {
              rowData[headerName[cellIndex] + "stype"] = cell.stype;
            }
          });

          return {
            id: row[0].value,
            originalId: row[0].value,
            ...rowData,
            rowIndexTracker: index,
            hasChildren: row[1].value,
            IsEqipmentActive: row[2].value === "1" ? true : false,
          };
        });

        let actionItem = null;
        let headerNameWithType = {};
        const coliumns = _response.headers
          .filter((col) => col.isVisible)
          .map((col, index) => {
            if (col.actions.length > 0) {
              actionItem = [...col.actions];
            }
            headerNameWithType[col.name] = col.type.toLowerCase();
            const colDefination = {
              field: col.name,
              headerName: col.text,
              minWidth: col.type.toLowerCase() === "bool" ? 50 : 100,
              flex: 1,
              headerClassName: col.name,
              filterable:
                col.name === "ChecklistFrequency" ||
                col.name == "HasScrapDocument"
                  ? false
                  : true,
              type: ["anlagestatus", "nio", "inspectionresult"].includes(
                col.name.toLowerCase(),
              )
                ? "singleSelect"
                : col.type.toLowerCase() === "bool"
                  ? "boolean"
                  : ["int", "float"].includes(col.type.toLowerCase())
                    ? "number"
                    : col.type.toLowerCase() === "datetime"
                      ? "date"
                      : "string",
              filterOperators: extractFilterOperator(
                col.type,
                col.name,
                localization,
              ),
              valueGetter:
                col.type.toLowerCase() === "datetime"
                  ? (params) => {
                      const cellValue = params.row[col.name];
                      return cellValue;
                    }
                  : undefined,
              valueFormatter: (params) => {
                if (
                  ["anlagestatus", "nio", "inspectionresult"].includes(
                    params.field.toLowerCase(),
                  )
                ) {
                  if (params.field.toLowerCase() === "anlagestatus") {
                    return params.value.toLowerCase() === "inbe"
                      ? localization.active
                      : localization.inActive;
                  } else if (
                    ["nio", "inspectionresult"].includes(
                      params.field.toLowerCase(),
                    )
                  ) {
                    return params.value.toLowerCase() === "true"
                      ? localization.nio
                      : localization.io;
                  }
                }

                return params.value;
              },
              renderCell: (params) => {
                let cellData = params.row[col.name];
                const cellColor =
                  params.row[col.name + "stype"] || "transparent";

                if (col.actions.length > 0) {
                  actionItem = col.actions;
                }
                if (
                  ["anlagestatus", "nio", "inspectionresult"].includes(
                    col.name.toLowerCase(),
                  )
                ) {
                  let backgroundColor;
                  let textColor = "#000";
                  let icon = null;
                  let tooltipText = "";
                  let nioText = "";
                  if (col.name.toLowerCase() === "anlagestatus") {
                    const isValueOk = cellData.toLowerCase() === "inbe";
                    cellData = isValueOk
                      ? localization.active
                      : localization.inActive;
                    icon = isValueOk ? (
                      <DoneIcon style={{ color: "#0A470A" }} />
                    ) : (
                      <CloseIcon style={{ color: "#A00" }} />
                    );
                    backgroundColor = isValueOk ? "#E3FBE3" : "#FBE3E3";
                    textColor = isValueOk ? "#0A470A" : "#A00";
                    tooltipText = isValueOk
                      ? localization.eqIsActive
                      : localization.eqIsNotActive;
                  } else if (
                    ["nio", "inspectionresult"].includes(col.name.toLowerCase())
                  ) {
                    backgroundColor =
                      cellData.toLowerCase() === "true" ? "#FBE3E3" : "#E3FBE3";
                    textColor =
                      cellData.toLowerCase() === "true" ? "#A00" : "#0A470A";

                    nioText =
                      cellData.toLowerCase() === "true"
                        ? localization.nio
                        : localization.io;
                  }

                  return (
                    <Tooltip title={tooltipText}>
                      <div
                        style={{
                          backgroundColor: backgroundColor,
                          padding: "0 6px 0 6px",
                          display: "flex",
                          alignItems: "center",
                          borderRadius: "15px",
                          color: textColor,
                        }}
                      >
                        {icon && <span>{icon}</span>}
                        <span>{nioText === "" ? cellData : nioText}</span>
                      </div>
                    </Tooltip>
                  );
                } else if (col.name.toLowerCase() === "hasscrapdocument") {
                  if (cellData == "1") {
                    return (
                      <div
                        style={{
                          padding: "5px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <LuView
                          style={{ cursor: "pointer" }}
                          size={20}
                          title={localization.viewScrapImages}
                          onClick={() => {
                            setEqupId(params.row.originalId);
                            setOpenScrapImageListView(true);
                          }}
                        />
                      </div>
                    );
                  } else {
                    return <></>;
                  }
                } else {
                  return (
                    <div
                      style={{
                        backgroundColor: cellColor,
                        padding: "5px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span className="tableCellTextStyle" title={cellData}>
                        {cellData}
                      </span>
                    </div>
                  );
                }
              },
              cellClassName: (params) => {
                let cellColor = params.row[col.name + "stype"];
                cellColor = cellColor
                  ? cellColor === "#F7C5C5"
                    ? "backgroundColorF7 MuiDataGridfdsfsd"
                    : "backgroundColorFc MuiDataGridfdsfsd"
                  : "MuiDataGridfdsfsd";

                return cellColor;
              },
            };
            if (["anlagestatus"].includes(col.name.toLowerCase())) {
              colDefination.valueOptions = [
                { value: "INBE", label: localization.active },
                { value: "AUSSER BETRIEB", label: localization.inActive },
              ];
            } else if (
              ["nio", "inspectionresult"].includes(col.name.toLowerCase())
            ) {
              colDefination.valueOptions = [
                { value: "true", label: localization.nio },
                { value: "false", label: localization.io },
              ];
            }
            return { ...colDefination };
          });

        const _columnItem = "InventarNr";
        const filterModelTable =
          itemSelectedFilterRef?.current.length > 0
            ? filterModel(
                itemSelectedFilterRef?.current,
                "ScrapEquipment",
                headerNameWithType,
              )
            : { items: [] };

        setTableData({
          columns: coliumns,
          data: formattedData,
          paginationData: { ...paginationData },
          gridAction: _gridAction,
          headerName: headerName,
          sortingModal: [
            {
              field:
                sortBy.key && headerName.includes(sortBy.key)
                  ? sortBy.key
                  : headerName.includes(_columnItem)
                    ? _columnItem
                    : firstItemOfColumn,
              sort: sortBy.order === "" ? "asc" : sortBy.order,
            },
          ],
          filterModel: filterModelTable,
          hearderType: headerNameWithType,
        });
      }
    },
    [sortBy, itemSelectedFilter, localization],
  );

  useEffect(() => {
    function updateEquipmentList() {
      setTableData(null);
      const res = equipmentGroupStore.getEquipmentListGrid();
      handleResponse(res);
      setGlobalSpinner(false);
    }
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_GRID_EQUIPMENTLIST_SUCCESS,
      updateEquipmentList,
    );

    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_GRID_EQUIPMENTLIST_SUCCESS,
        updateEquipmentList,
      );
    };
  }, [sortBy, handleResponse]);

  useEffect(() => {
    function getSaveFilterResultSuccess() {
      const res = gridColSettingStore.getSaveFilterResult();

      if (res.length > 0) {
        setSaveFilterList(res);
      } else {
        setSaveFilterList([]);
      }
    }

    function SaveFilterResultFailure() {}

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_LIST_SUCCESS,
      getSaveFilterResultSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.GET_SAVE_FILTER_LIST_FAILURE,
      SaveFilterResultFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_LIST_SUCCESS,
        getSaveFilterResultSuccess,
      );

      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.GET_SAVE_FILTER_LIST_FAILURE,
        SaveFilterResultFailure,
      );
    };
  }, []);

  const getEquipmentGroupByOrganisations = () => {
    setGlobalSpinner(true);
    EquipmentGroupActions.getOrganisationsEquipmentGroup();
  };

  useEffect(() => {
    getEquipmentGroupByOrganisations();
    function getEquipmentGroupSuccess() {
      const res = equipmentGroupStore.getOrgEquipmentGroupResult();

      if (res.length > 0) {
        let sortList = res.sort((a, b) =>
          a.plantId > b.plantId ? 1 : a.plantId < b.plantId ? -1 : 0,
        );

        setEgList(sortList);
        if (sortList.length > 0) {
          setEgId(sortList[0].id);
        }
      } else {
        setEgList([]);
      }
    }
    function getEquipmentGroupFailure() {
      const res = equipmentGroupStore.getOrgEquipmentGroupResult();

      setGlobalSpinner(false);
    }
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_ORG_EQUIPMENT_SUCCESS,
      getEquipmentGroupSuccess,
    );
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_ORG_EQUIPMENT_FAILURE,
      getEquipmentGroupFailure,
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_ORG_EQUIPMENT_SUCCESS,
        getEquipmentGroupSuccess,
      );
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_ORG_EQUIPMENT_FAILURE,
        getEquipmentGroupFailure,
      );
    };
  }, []);

  useEffect(() => {
    if (egId && egId !== null && egId !== "0") {
      UpdateSelectedAnlageG(egId);
      setGlobalSpinner(true);
      loadData(true);
    }
  }, [egId]);

  // const handleEquipmentListApi = useCallback(
  //   (filterList, page, pageSize, isSorting, sortingModal) => {
  //     setGlobalSpinner(true);

  //     EquipmentGroupActions.getEquipmentList2(
  //       "ScrapEquipment",
  //       isSorting
  //         ? sortingModal[0]["sort"]
  //         : sortBy.order
  //           ? sortBy.order
  //           : "asc",
  //       egId,
  //       parseInt(page),
  //       parseInt(pageSize),
  //       isSorting
  //         ? sortingModal[0]["field"]
  //         : sortBy.key !== ""
  //           ? sortBy.key
  //           : "InventarNr",
  //       null,
  //       filterList,
  //     );
  //   },
  //   [sortBy, egId],
  // );

  useEffect(() => {
    if (!shouldFetch || !apiArgs) return;

    setGlobalSpinner(true);

    EquipmentGroupActions.getEquipmentList2(
      "ScrapEquipment",
      apiArgs.isSorting
        ? apiArgs.sortingModal[0]["sort"]
        : sortBy.order || "asc",
      egId,
      parseInt(apiArgs.page),
      parseInt(apiArgs.pageSize),
      apiArgs.isSorting
        ? apiArgs.sortingModal[0]["field"]
        : sortBy.key !== ""
          ? sortBy.key
          : "InventarNr",
      null,
      apiArgs.filterList,
    );

    setShouldFetch(false);
  }, [shouldFetch, apiArgs, egId]);

  function handleFilter(_filterList, key, fieldName) {
    let filterValue = [];
    if (["apply"].includes(key)) {
      const { filterList, IsAnlageLastCheckValue, fieldFound } =
        FilterApplyHandle(
          _filterList,
          state,
          "ScrapEquipment",
          tableData.headerName,
          tableData.hearderType,
        );

      filterValue = filterList;

      updateListSelectedFilter([...filterValue]);
    } else {
      updateListSelectedFilter([]);
      updateSelectedFilter("");
    }

    //handleEquipmentListApi(filterValue, 1, tableData.paginationData.pageSize);
    setApiArgs((prev) => ({
      ...prev,
      filterList: filterValue,
      page: 1,
      pageSize: tableData.paginationData.pageSize,
    }));
    setShouldFetch(true);
  }

  function handleFilterSave(_filterList, key, fieldName, _id) {
    let filterValue = [];
    const { filterList, IsAnlageLastCheckValue, fieldFound } =
      FilterApplyHandle(
        _filterList,
        state,
        "ScrapEquipment",
        tableData.headerName,
        tableData.hearderType,
      );
    const filterDetails = {
      ID: _id,
      eqgID: egId,
      ReportCode: "ScrapEquipment",
      SettingType: "Filter",
      Title: fieldName,
      SettingValue: filterList,
    };

    setGlobalSpinner(true);
    GridColumn_SettingActions.saveFilterGrid(filterDetails);
    filterValue = filterList;

    if (!fieldFound && state !== "All") {
      filterValue.push(dropDownFilter("AnlageStatus", state));
    }
    if (IsAnlageLastCheckValue) {
      setState(IsAnlageLastCheckValue);
      updateEquipmentStatus(IsAnlageLastCheckValue);
    }
  }

  useEffect(() => {
    function getFilterSaveSuccess() {
      var res = gridColSettingStore.getSavedFilterResult();
      if (res) {
        const _parseRes = JSON.parse(res[["settingValue"]]);
        GridColumn_SettingActions.getSaveFilterList(egId, "ScrapEquipment");

        const _filterList = CreateFilterModel(
          [..._parseRes],
          "ScrapEquipment",
          tableData.hearderType,
        );
        updateSelectedFilter([
          {
            id: res["id"],
            title: res["title"],
          },
        ]);
        updateListSelectedFilter(_filterList);
        // handleEquipmentListApi(
        //   _filterList,
        //   1,
        //   tableData.paginationData.pageSize,
        // );
        setApiArgs((prev) => ({
          ...prev,
          filterList: _filterList,
          page: 1,
          pageSize: tableData.paginationData.pageSize,
        }));
        setShouldFetch(true);
        toast.success(localization.filterSave);
      }
    }

    function getFilterSaveFailure() {
      var res = gridColSettingStore.getSavedFilterResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_FILTER_SUCCESS,
      getFilterSaveSuccess,
    );

    gridColSettingStore.addChangeListener(
      GridColSettingConstants.SAVE_GRID_FILTER_FAILURE,
      getFilterSaveFailure,
    );
    return () => {
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_FILTER_SUCCESS,
        getFilterSaveSuccess,
      );
      gridColSettingStore.removeChangeListener(
        GridColSettingConstants.SAVE_GRID_FILTER_FAILURE,
        getFilterSaveFailure,
      );
    };
  }, [tableData]);

  function handlePagination(pageModel, _filterList) {
    handlePaginationCallApi(pageModel, _filterList);
  }

  function handlePaginationCallApi(pageValue, _filterlist) {
    UpdateCurrentPage(pageValue.page);
    UpdatePageSize(pageValue.pageSize);
    setGlobalSpinner(true);
    //handleEquipmentListApi(_filterlist, pageValue.page, pageValue.pageSize);
    setApiArgs((prev) => ({
      ...prev,
      filterList: _filterlist,
      page: pageValue.page,
      pageSize: pageValue.pageSize,
    }));
    setShouldFetch(true);
  }

  function handleSorting(sortingModal, _filterList) {
    // handleEquipmentListApi(
    //   _filterList,
    //   1,
    //   tableData.paginationData.pageSize,
    //   true,
    //   sortingModal,
    // );
    setApiArgs((prev) => ({
      ...prev,
      filterList: _filterList,
      page: 1,
      pageSize: tableData.paginationData.pageSize,
      isSorting: true,
      sortingModal,
    }));
    setShouldFetch(true);
    UpdateSortBy({
      key: sortingModal ? sortingModal[0]["field"] : sortBy.key,
      order: sortingModal ? sortingModal[0]["sort"] : sortBy.order,
    });
  }

  function handleDropDownApiCall(stateValue, filterModel) {
    const { updatedConditions, dropDownCondition } = DropDownChange(
      stateValue,
      filterModel,
      "ScrapEquipment",
    );

    setTableData(null);
    updateListSelectedFilter(updatedConditions);

    const tempFilter =
      dropDownCondition.length > 0
        ? [...updatedConditions, ...dropDownCondition]
        : updatedConditions;

    //handleEquipmentListApi(tempFilter, 1, tableData.paginationData.pageSize);
    setApiArgs((prev) => ({
      ...prev,
      filterList: tempFilter,
      page: 1,
      pageSize: tableData.paginationData.pageSize,
    }));
    setShouldFetch(true);
  }

  function handleGridSettingChange(_filterList) {
    setTableData(null);
    // handleEquipmentListApi(
    //   _filterList,
    //   tableData.paginationData.currentPage,
    //   tableData.paginationData.pageSize,
    // );
    setApiArgs((prev) => ({
      ...prev,
      filterList: _filterList,
      page: tableData.paginationData.currentPage,
      pageSize: tableData.paginationData.pageSize,
    }));
    setShouldFetch(true);
  }

  return (
    <>
      <div
        style={{ height: "100%", width: "100%", overflow: "auto" }}
        id="content"
      >
        <div id="dataGrid">
          <div style={{ height: "100%", width: "100%", overflow: "auto" }}>
            <div
              className="form-group d-flex align-items-center"
              style={{ marginBottom: "15px" }}
            >
              <label htmlFor="equipmentGroupList" className="mr-3">
                {localization.equipmentGroup}
              </label>
              <select
                className="form-control"
                id="equipmentGroupList"
                name="equipmentGroupList"
                required
                value={egId}
                onChange={(e) => {
                  setEgId(e.target.value);
                }}
                style={{ maxWidth: "300px" }}
              >
                <option value="0" disabled>
                  {localization.selectEquipmentGroup}
                </option>
                {egList.map((row, index) => {
                  return (
                    <option key={index} value={row.id}>
                      {row.bezeichnungsDisplay}
                    </option>
                  );
                })}
              </select>
            </div>

            {tableData && (
              <MuiDataGridPro
                tableData={tableData}
                handlePaginationCall={handlePagination}
                handleFilter={handleFilter}
                saveFilterHandler={handleFilterSave}
                pinnedColumns={pinnedColumns}
                handleColumnPin={handleColumnPin}
                handleSorting={handleSorting}
                reportCode="ScrapEquipment"
                saveFilterlist={saveFilterlist}
              >
                <GridHeaderBar
                  handleDropChange={handleDropDownApiCall}
                  reportCode="ScrapEquipment"
                  gridAction={tableData.gridAction}
                  rowCount={tableData.paginationData.rowCount}
                  handleGridSettingChange={handleGridSettingChange}
                  hasRow={
                    tableData
                      ? tableData.paginationData.rowCount > 0
                        ? true
                        : false
                      : false
                  }
                  handleBulkOperationSuccess={() => {}}
                />
              </MuiDataGridPro>
            )}
          </div>
        </div>
      </div>
      {openScrapImageListView && (
        <ScrapImageList
          isOpen={openScrapImageListView}
          setOpenScrapImageListView={setOpenScrapImageListView}
          equpId={equpId}
        />
      )}
    </>
  );
}
